import React from 'react';

// interface to declare all our prop types
interface Props {
  buttonLabel: string;
  onClick?: () => void;
  variant?: string; // default, primary, info, success, warning, danger, dark
  size?: string; // sm, md, lg
  disabled?: boolean;
  position?: string;
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
}

// button component, consuming props
const TertiaryButton: React.FC<Props> = ({
  buttonLabel,
  onClick,
  variant = 'default',
  size = 'md',
  disabled,
  position = '',
  iconLeft,
  iconRight,
  ...rest
}) => {
  return (
    <button
      type="submit"
      className={
        `bg-neutral1 transition duration-300 ease-in-out transform hover:bg-primary1 hover:text-primary2 gap-2 py-2 px-4 w-auto rounded-lg inline-flex items-center justify-end ${variant} ${size} ${position}` +
        (disabled ? ' disabled' : '')
      }
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {iconLeft} {buttonLabel} {iconRight}
    </button>
  );
};

export default TertiaryButton;
